<template>
    <div class="bg-white p-4 rounded-xl">
      <div
        :class="`d-lg-flex ${
          filterDate ? 'justify-content-between' : 'justify-content-end'
        }`"
      >
        <div v-if="filterDate">
          <div
            class="d-lg-flex d-flex gap-3 mb-2 mb-lg-0 align-items-center justify-content-between w-100"
          >
            <div class="text-left w-100">
              <label>Start Date</label>
              <BFormInput
                type="date"
                placeholder="dd/mm/yyyy"
                :model-value="startDate"
                @update:modelValue="$emit('update:startDate', $event)"
              />
            </div>
            <div class="text-left w-100">
              <label>End Date</label>
              <BFormInput
                type="date"
                :model-value="endDate"
                @update:modelValue="$emit('update:endDate', $event)"
              />
            </div>
          </div>
        </div>
  
        <div
          :class="`d-lg-flex align-items-center ${
            cta ? 'gap-lg-3 justify-content-end' : 'justify-content-end'
          }`"
        >
          <div class="d-flex gap-3 mb-2 mb-lg-0 align-items-center">
            <BButton
              v-if="filterModal"
              class="btn-filter d-lg-flex align-items-center"
              variant="light"
              @click="$emit('showFilter')"
            >
              <i class="fas fa-filter me-1"></i>
              <span>Filter</span>
            </BButton>
  
            <BInputGroup class="border rounded-lg">
              <template #append>
                <BButton variant="white">
                  <i class="ios ion-ios-search text-black"></i>
                </BButton>
              </template>
              <BFormInput
                type="text"
                class="border-0"
                placeholder="Search"
                v-model="localSearchQuery"
              />
            </BInputGroup>
          </div>
  
          <div class="d-grid" v-if="cta && ctaText">
            <BButton class="btn-cta" variant="primary" @click="$emit('action')">
              <i class="fas fa-plus"></i>
              {{ ctaText }}
            </BButton>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, watch } from "vue";
  import { BButton, BFormInput, BInputGroup } from "bootstrap-vue-next";
  
  export default {
    name: "ActionContent",
    components: {
      BButton,
      BFormInput,
      BInputGroup,
    },
    props: {
      ctaText: String,
      filterDate: {
        type: Boolean,
        default: true,
      },
      startDate: String,
      endDate: String,
      filterModal: {
        type: Boolean,
        default: true,
      },
      cta: {
        type: Boolean,
        default: true,
      },
      search: {
        type: String,
        default: "",
      },
    },
    emits: ["search-query", "update:startDate", "update:endDate", "showFilter", "action", "update:search"],
    setup(props, { emit }) {
      const localSearchQuery = ref(props.search);
  
      // Sinkronisasi dari parent ke lokal
      watch(
        () => props.search,
        (val) => {
          if (val !== localSearchQuery.value) {
            localSearchQuery.value = val;
          }
        }
      );
  
      // Debounce helper
      const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => func(...args), delay);
        };
      };
  
      // Emit pencarian dengan validasi
      const emitSearchQuery = debounce(() => {
        const keyword = localSearchQuery.value.trim();
        emit("search-query", keyword.length >= 2 ? keyword : "");
      }, 300);
  
      // Trigger saat user mengetik
      watch(localSearchQuery, () => {
        emitSearchQuery();
      });
  
      return {
        localSearchQuery,
      };
    },
  };
  </script>
  
  <style scoped>
  @media screen and (min-width: 768px) {
    .col-lg-4 {
      min-width: 184px;
    }
  }
  </style>
  